export const INCREMENT = 'INCREMENT'
export const DECREMENT = 'DECREMENT'
export const TODO_DATE = 'TODO_DATE'
export const NEW_NOTE = 'NEW_NOTE'
export const COMPLETE_NOTE = 'COMPLETE_NOTE'



/** WEBPACK FOOTER **
 ** ./src/constants/actionTypes.js
 **/